import { render } from "./CreateSubjectDataTable.vue?vue&type=template&id=6c267178"
import script from "./CreateSubjectDataTable.vue?vue&type=script&lang=js"
export * from "./CreateSubjectDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__